import { useCallback } from 'react';
import { useDropzone, type FileRejection } from 'react-dropzone';
import { MAX_IMAGES_PER_COMMENT, ACCEPTED_IMAGE_ACCEPT, MAX_FILE_SIZE_BYTES } from './createEscalation.constants';
import { PendingFile } from './createEscalation.models';
import { onDropAccepted, onDropRejected } from './createEscalation.utils';

export const ATTACHMENT_BUTTON_TITLE_DISABLED = `Maximum ${MAX_IMAGES_PER_COMMENT} images allowed.`;
export const ATTACHMENT_BUTTON_TITLE = 'Attach images (PNG, JPEG, max 10 MB)';

export function useCommentDropzone(
    pendingFiles: PendingFile[],
    setPendingFiles: React.Dispatch<React.SetStateAction<PendingFile[]>>
) {
    const dropAccepted = useCallback(
        (acceptedFiles: File[]) => onDropAccepted(acceptedFiles, setPendingFiles),
        [setPendingFiles]
    );
    const dropRejected = useCallback((fileRejections: FileRejection[]) => onDropRejected(fileRejections), []);

    const maxNewFiles = Math.max(0, MAX_IMAGES_PER_COMMENT - pendingFiles.length);
    const dropzoneDisabled = maxNewFiles === 0;

    const { getRootProps, getInputProps, open } = useDropzone({
        accept: ACCEPTED_IMAGE_ACCEPT,
        maxSize: MAX_FILE_SIZE_BYTES,
        maxFiles: maxNewFiles,
        onDropAccepted: dropAccepted,
        onDropRejected: dropRejected,
        noClick: true,
        noKeyboard: true,
        disabled: dropzoneDisabled,
    });

    const attachmentButtonTitle = dropzoneDisabled ? ATTACHMENT_BUTTON_TITLE_DISABLED : ATTACHMENT_BUTTON_TITLE;

    return {
        getRootProps,
        getInputProps,
        open,
        maxNewFiles,
        dropzoneDisabled,
        attachmentButtonTitle,
    };
}